import { render } from "./md-radio-button-off.vue?vue&type=template&id=15535dfe"
import script from "./md-radio-button-off.vue?vue&type=script&lang=js"
export * from "./md-radio-button-off.vue?vue&type=script&lang=js"
script.render = render

export default script